<template>
  <div class="page-container">
    <div class="top-bg-box">
      <van-image :src="couponCenterBg" width="100%" />
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="background-color: #fd6f54">
      <div class="coupon-list-box">
        <van-list
          class="list-container"
          v-model:loading="loading"
          :finished="finished"
          :immediate-check="false"
          @load="getList"
        >
          <div
            class="coupon-item"
            :class="{ 'coupon-item-bg': item.have_num }"
            v-for="item in list"
            :key="item.activity_id"
            @click="goCouponGoodsList(item.activity_id)"
          >
            <div class="coupon-item-left">
              <div class="coupon-name">{{ item.use_type }}<van-icon :size="12" color="#999" name="arrow" /></div>
              <div class="goods-list-box">
                <template v-if="item.goods_list.length">
                  <div
                    class="goods-item"
                    @click.stop="goGoodsDetails(subItem.goods_id)"
                    v-for="subItem in item.goods_list"
                    :key="subItem.goods_id"
                  >
                    <van-image
                      class="goods-pic"
                      :src="subItem.goods_logo"
                      :width="transPxToRem(64)"
                      :height="transPxToRem(64)"
                    />
                    <div class="goods-price">¥{{ subItem.price }}</div>
                  </div>
                </template>
                <div class="goods-empty" v-else>
                  <van-image class="goods-pic" src="" :width="transPxToRem(64)" :height="transPxToRem(64)" />
                  <div class="goods-empty-cover">暂无商品</div>
                </div>
              </div>
            </div>
            <div class="divider-box"></div>
            <div class="coupon-item-right">
              <couponPrice :price="item.coupon_value" />
              <div class="full-amount-des">
                {{
                  item.use_condition_type === 1
                    ? '无门槛'
                    : `满${item.use_condition_value}${item.use_condition_type === 2 ? '元' : '件'}可用`
                }}
              </div>
              <template v-if="item.have_num">
                <van-button class="btn use-btn" v-if="item.have_num >= item.limit_num" round>去使用</van-button>
                <van-button class="btn get-btn" v-else round @click.stop="receiveCoupon(item.activity_id)"
                  >再次领取</van-button
                >
              </template>
              <van-button class="btn get-btn" v-else round @click.stop="receiveCoupon(item.activity_id)"
                >立即领取</van-button
              >
              <div class="coupon-tag" v-if="item.have_num > 1">持有{{ item.have_num }}张</div>
            </div>
            <div class="cover"></div>
          </div>
          <template #loading>
            <div class="loading-box"><van-loading color="#fff" /></div>
          </template>
          <template #finished>
            <div class="finished-text">{{ finishedText }}</div>
          </template>
        </van-list>
        <div class="empty-box" v-if="list.length == 0 && !loading">
          <van-empty image-size="240" image="https://i.xurl.cn/x_dsx_wxapp/empty/coupon.png" description="暂无优惠券" />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed } from 'vue'
import { showToast } from 'vant'
import couponPrice from './component/couponPrice.vue'
import couponCenterBg from '@/assets/img/coupon_center_bg.png'
import { getCouponActivityList, receiveActivityCoupon, couponReceiveId } from '@/api/coupon'
import { transPxToRem } from '@/utils'
import usePage from '@/hooks/usePage'
import { WxPage } from '../../enum'

const { navigateTo, goWxAppPage } = usePage()

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  finished.value = false
  list.value = []
  pageParams.page = 1
}

const getList = async () => {
  loading.value = true
  try {
    const resData = await getCouponActivityList(pageParams)
    list.value.push(...resData.list)
    console.log(list.value)
    pageParams.page++
    finished.value = resData.list.length === 0
  } catch {
    finished.value = true
  } finally {
    // finished.value = true
    loading.value = false
  }
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

const receiveCoupon = async activityId => {
  try {
    const res = await receiveActivityCoupon({ activity_id: activityId })
    if (res && !res.code) {
      const item = list.value.filter(d => d.activity_id === activityId)[0]
      item.have_num++
      showToast('领券成功')
    } else {
      showToast(res.message)
    }
  } catch {}
}

const goGoodsDetails = goodsId => {
  goWxAppPage(`${WxPage.goodsDetails}?goodsId=` + goodsId + '&comeType=9')
}

const goCouponGoodsList = async activityId => {
  const resData = await couponReceiveId({ activity_id: activityId })
  if (resData) {
    const { rid } = resData
    navigateTo(`/couponGoodsList?activityId=${activityId}&&rid=${rid || ''}`)
  }
}
onMounted(async () => {
  await getList()
  // document.getElementById('app').style.background = '#fd6f54'
})
</script>
<style lang="less" scoped>
@primary-color: #fd6f54;
@font-primary-color: #ff6262;
.page-container {
  font-size: 14px;
  // overflow: hidden;
  min-height: 100vh;
  .top-bg-box {
    height: 196px;
    background: linear-gradient(122deg, #fd7358 0%, #fd5639 100%);
  }
  .coupon-list-box {
    margin-top: 40px;
    background-color: #fd6f54;
    .coupon-item {
      display: flex;
      padding-left: 12px;
      border-radius: 8px;
      background-color: white;
      justify-content: space-between;
      overflow: hidden;
      align-items: center;
      position: relative;
      margin: 12px;
      // background-color: white;
      background-position: 310px 82px;
      background-repeat: no-repeat;
      background-size: 50px;
      .coupon-item-left {
        width: 230px;
        padding: 8px 0;
        .coupon-name {
          font-size: 12px;
          font-weight: 500;
          color: #222222;
          line-height: 16px;
          margin-bottom: 6px;
        }
        .goods-list-box {
          display: flex;
          .goods-pic-sty {
            border-radius: 4px;
            margin-bottom: 4px;
          }
          .goods-item {
            margin-right: 8px;
            .goods-pic {
              .goods-pic-sty();
            }
            .goods-price {
              text-align: center;
              font-size: 10px;
              font-weight: 500;
              color: #222222;
              line-height: 14px;
            }
          }
          .goods-empty {
            position: relative;
            .goods-pic-sty();
            .goods-empty-cover {
              .goods-pic-sty();
              position: absolute;
              width: 64px;
              height: 64px;
              color: #e9e9e9;
              top: 0;
              left: 0;
              font-size: 12px;
              text-align: center;
              line-height: 64px;
              opacity: 0.5;
              background-color: #000;
            }
          }
        }
      }
      .divider-box {
        position: relative;
        // width: 10px;
        height: 100px;
        border-right: dashed #d8d8d8 1px;
        .red-circle {
          content: '';
          display: block;
          position: absolute;
          width: 16px;
          height: 16px;
          background-color: @primary-color;
          border-radius: 50%;
          right: -8px;
        }
        &::before {
          .red-circle();
          top: -21px;
        }
        &::after {
          .red-circle();
          bottom: -23px;
        }
        // .divider {

        // }
      }
      .coupon-item-right {
        text-align: center;
        font-size: 12px;
        color: @font-primary-color;
        width: 92px;
        .full-amount-des {
          // margin-top: 5px;
          font-family: Avenir;
          margin-bottom: 8px;
          font-size: 10px;
          // font-family: Avenir;
        }
        .btn {
          height: 20px;
          font-size: 10px;
          border: 1px solid #ff6262;
          width: 68px;
          padding: 0;
        }
        .use-btn {
          color: @font-primary-color;
          background-color: #0000;
        }
        .get-btn {
          background-color: @primary-color;
          color: #fff;
        }
        .coupon-stamp {
          position: absolute;
          right: -22px;
          bottom: -26px;
        }
        .coupon-tag {
          position: absolute;
          display: inline-block;
          padding: 0 3px;
          top: 0px;
          right: 0px;
          height: 14px;
          line-height: 14px;
          background: linear-gradient(122deg, #ffa086 0%, #fb643e 100%);
          font-size: 9px;
          text-align: center;
          color: white;
          border-bottom-left-radius: 8px;
          border-top-right-radius: 8px;
        }
      }
    }
    .coupon-item-bg {
      background-image: url(../../assets/img/coupon_stamp.png);
    }
    .empty-box {
      background-color: #fff;
      margin: 12px;
      height: calc(100vh - 250px);
      border-radius: 8px;
    }
    .loading-box {
      color: #fff;
      text-align: center;
    }
    .finished-text {
      text-align: center;
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>
